import QuestionAnswer from '@mui/icons-material/QuestionAnswer'
import { Box, Icon, Typography, Button } from '@mui/material'
import I18n from 'i18n-js'

import { helpWidget } from '@src/lib/HelpWidget'

import AuthCard from '../AuthCard'
import AuthPageLayout from '../AuthPageLayout'

import RequestAccessForm from './RequestAccessForm'

const RequestAccessView: React.FC<React.PropsWithChildren> = () => {
  return (
    <AuthPageLayout>
      <AuthCard>
        <RequestAccessForm />
      </AuthCard>

      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography color="textSecondary">
          <Icon color="inherit" style={{ verticalAlign: 'middle' }}>
            <QuestionAnswer />
          </Icon>
          <span>{I18n.t('auth.needHelpQuestionMark')}</span>
        </Typography>

        <Button color="primary" onClick={helpWidget.open}>
          {I18n.t('auth.chatWithOurSupportTeam')}
        </Button>
      </Box>
    </AuthPageLayout>
  )
}

export default RequestAccessView
